import { render, staticRenderFns } from "./BigNavIconNoRouter.vue?vue&type=template&id=a752b840&scoped=true&"
import script from "./BigNavIconNoRouter.vue?vue&type=script&lang=js&"
export * from "./BigNavIconNoRouter.vue?vue&type=script&lang=js&"
import style0 from "./BigNavIconNoRouter.vue?vue&type=style&index=0&id=a752b840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a752b840",
  null
  
)

export default component.exports